export default {"src":"/_next/static/media/business-icon.5eed339b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};